import { isDefined } from '@hover/utilities';

import type { AiImageEditsFragment } from 'src/shared/graphql/generated';

import { MY_UPLOAD_STYLE } from '../static_values';
import type {
  AiOrSampleDisplayImage,
  AiOrSampleGeneratedImage,
} from '../types';
import { isDisplay, isMyUpload, pickImage } from '../types';

import { useHomeownerTranslate } from './useHomeownerTranslate';

// TODO: (MEOW-5776) With the migration to product catalog prompts, we
//  no longer have name available for paint products in the edit data. We'll
//  need to get the name from product catalog. As a temporary solution, we
//  fall back to the hex code to ensure our tests can still identify generated
//  images
const getEditNames = (edits: AiImageEditsFragment) =>
  Object.values(edits)
    .map(edit =>
      edit &&
      typeof edit === 'object' &&
      '__typename' in edit &&
      (edit.__typename === 'AiImageRegionEdits' ||
        edit.__typename === 'AiImageWallEdits')
        ? edit.paint?.name ?? edit.paint?.hex ?? edit.material?.name
        : null,
    )
    .filter(isDefined);

export const useAltTextForImage = (
  image: AiOrSampleDisplayImage | AiOrSampleGeneratedImage | undefined | null,
) => {
  const t = useHomeownerTranslate();

  if (!image) return '';

  if (isDisplay(image) && isMyUpload(image)) {
    return t('images.myUploadAlt', { spaceType: image.spaceType });
  }

  const { edits, style, spaceType } = pickImage(image);

  if (edits) {
    const names = getEditNames(edits);

    if (style === MY_UPLOAD_STYLE) {
      return t('images.editedAlt', { edits: names, spaceType });
    }

    return t('images.styledAndEditedAlt', { edits: names, style, spaceType });
  }

  return t('images.styledAlt', { style, spaceType });
};
